import { useState } from 'react';
import { useDebounce } from '@gonfalon/async/useDebounce';
// oxlint-disable-next-line no-restricted-imports
import { Label } from '@launchpad-ui/core';

import { SelectTeamOrMember } from '#components/SelectTeamOrMember/SelectTeamOrMember';
import type { TeamOrMemberOptionType } from '#components/SelectTeamOrMember/SelectTeamOrMemberUtils';
import useTeamOrMemberOptions from '#hooks/useTeamOrMemberOptions';
import { trackNewMaintainerSelectedFromDropdown } from '#utils/flags/flagAnalytics';
import type { Member } from '#utils/members/records/Member';
import type { Team } from '#utils/teams/records/Team';

export type SelectTeamOrMemberContainerProps = {
  disabled?: boolean;
  id?: string;
  onChange(maintainer?: Member | Team): void;
  placeholder?: string;
  value?: string;
  showLabel?: boolean;
  ariaLabel?: string;
  className?: string;
  teamOnly?: boolean;
};

export const SelectTeamOrMemberContainer = ({
  disabled,
  id,
  onChange,
  placeholder,
  value,
  ariaLabel,
  showLabel,
  className,
  teamOnly,
}: SelectTeamOrMemberContainerProps) => {
  const [searchQuery, setSearchQuery] = useState('');
  const { isReady, options } = useTeamOrMemberOptions({ searchQuery, selectedValue: value, teamOnly });

  const handleChange = (option: TeamOrMemberOptionType) => {
    trackNewMaintainerSelectedFromDropdown(option?.kind);
    // We pass the selected member or team back to the form
    onChange(option.member || option.team);
  };

  const handleInputChange = useDebounce(setSearchQuery, 150);

  return (
    <>
      {showLabel && ariaLabel && id && <Label htmlFor={id}>{ariaLabel}</Label>}
      <SelectTeamOrMember
        className={className}
        disabled={disabled}
        id={id}
        onChange={handleChange}
        onInputChange={handleInputChange}
        options={options}
        placeholder={placeholder}
        value={value}
        isLoading={!isReady}
      />
    </>
  );
};
